import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Toaster } from "@/components/ui/sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Вход выполнен");
      navigate("/admin");
    } catch (err) {
      const msg = formatApiError(err, "Не удалось войти");
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-5 py-10 relative">
      <div className="pointer-events-none select-none absolute -top-10 left-1/2 -translate-x-1/2 font-heading text-[28vw] md:text-[18vw] text-burgundy/5 leading-none">
        ЩЁТКА
      </div>

      <div className="relative w-full max-w-md">
        <div className="absolute -top-4 -left-4 right-4 bottom-4 border-2 border-burgundy -z-10" />
        <div className="bg-cream-paper border-2 border-burgundy p-8 md:p-12">
          <div className="flex items-center gap-3 text-burgundy mb-8">
            <span className="font-heading text-4xl md:text-5xl leading-none">ЩЁТКА</span>
            <span className="text-[10px] uppercase tracking-[0.28em] font-bold text-muted_ink">Админка</span>
          </div>

          <h1 className="font-heading text-5xl text-ink heading-tight">Вход</h1>
          <p className="mt-4 lede text-ink/80">
            Панель мастерской. Введите email и пароль администратора.
          </p>

          <form onSubmit={submit} className="mt-10 space-y-6" data-testid="admin-login-form">
            <div>
              <label className="block text-[11px] uppercase tracking-[0.24em] font-bold text-muted_ink mb-2">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                autoComplete="email"
                className="input-vintage"
                data-testid="admin-login-email"
              />
            </div>
            <div>
              <label className="block text-[11px] uppercase tracking-[0.24em] font-bold text-muted_ink mb-2">Пароль</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                className="input-vintage"
                data-testid="admin-login-password"
              />
            </div>

            {error && (
              <div className="border-2 border-burgundy bg-burgundy/5 text-burgundy px-4 py-3 text-sm font-medium" data-testid="admin-login-error">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full disabled:opacity-60"
              data-testid="admin-login-submit"
            >
              <LogIn size={16} strokeWidth={2.5} />
              {loading ? "Входим…" : "Войти"}
            </button>
          </form>

          <p className="mt-8 text-center text-[11px] uppercase tracking-[0.24em] text-muted_ink">
            ✦ Только для сотрудников мастерской ✦
          </p>
        </div>
      </div>

      <Toaster
        position="top-right"
        toastOptions={{
          style: { background: "#F4E9D2", color: "#1A0E07", border: "2px solid #4A1419", borderRadius: 0 },
        }}
      />
    </div>
  );
}
